<template>
    <CardPage :section="20" :page="4" :backOverrideFunction="backClick" ref="cardPage">
        <v-slide-x-reverse-transition hide-on-leave>
            <div v-if="1 === step">
                <p class="headline text-xs-center">1. Goal</p>
                <p v-if="goal === 1">You've already done this! Here is your goal:</p>
                <p v-else>Here is your next goal:</p>
                <div class="caption font-weight-bold mb-1">Goal #{{ goal }}: {{ goalCategory() }}</div>
                <p>{{ goalText() }}</p>
            </div>
        </v-slide-x-reverse-transition>
        <v-slide-x-reverse-transition hide-on-leave>
            <div v-if="2 === step">
                <p class="headline text-xs-center">2. Steps</p>
                <p v-if="goal === 1">Next, you’re going to come up with some SOLID, do-able, and realistic steps on how you plan to get there.</p>
                <p v-else>Come up with some SOLID, do-able, and realistic steps on how you plan to get there.</p>
                <div class="caption font-weight-bold mb-1">Goal #{{ goal }}: {{ goalCategory() }}</div>
                <p>{{ goalText() }}</p>
                <v-textarea outline placeholder="Steps" :rows="4" auto-grow v-model="goalSteps"></v-textarea>
            </div>
        </v-slide-x-reverse-transition>
        <v-slide-x-reverse-transition hide-on-leave>
            <div v-if="3 === step">
                <p class="headline text-xs-center">3. Barrier</p>
                <p v-if="goal === 1">
                    Next comes a little harder part… what might hold you back or give you problems following through? For example, if I want to stop smoking
                    cigarettes and my boyfriend smokes, when I see him smoking I may be tempted to start again.
                </p>
                <p v-else>
                    What might hold you back or give you problems following through? For example, if I want to stop smoking cigarettes and my boyfriend smokes,
                    when I see him smoking I may be tempted to start again.
                </p>
                <div class="caption font-weight-bold mb-1">Goal #{{ goal }}: {{ goalCategory() }}</div>
                <p>{{ goalText() }}</p>
                <v-textarea outline placeholder="Barrier" :rows="4" auto-grow v-model="goalBarrier"></v-textarea>
            </div>
        </v-slide-x-reverse-transition>
        <v-slide-x-reverse-transition hide-on-leave>
            <div v-if="4 === step">
                <p class="headline text-xs-center">4. Plan</p>
                <p>
                    Finally, write down what you will do in the face of that challenge to stick to your action plan. In the case of my boyfriend smoking
                    cigarettes I may ask him to try not to smoke around me, or I could go for a walk when he has a cigarette, or leave the room.
                </p>
                <div class="caption font-weight-bold mb-1">Goal #{{ goal }}: {{ goalCategory() }}</div>
                <p>{{ goalText() }}</p>
                <v-textarea outline placeholder="Plan" :rows="4" auto-grow v-model="goalPlan"></v-textarea>
            </div>
        </v-slide-x-reverse-transition>
        <v-slide-x-reverse-transition hide-on-leave>
            <div v-if="5 === step">
                <p>
                    On the next page, take a screen shot of your Action Plan so you have it for yourself! These Action Plans can also be used as you keep
                    heading forward, and you can refer to it when you need it or update it when things change. It’s also just a helpful way to think about your
                    goals. You can also use these same steps to think through and plan out your future goals.
                </p>
            </div>
        </v-slide-x-reverse-transition>
        <v-slide-x-reverse-transition hide-on-leave>
            <div v-if="6 === step">
                <v-container fluid>
                    <v-layout row wrap align-start>
                        <v-flex xs3>
                            <p class="caption font-weight-bold">Goal:</p>
                        </v-flex>
                        <v-flex xs9>
                            <p class="goal-text">{{ goalText() }}</p>
                        </v-flex>
                    </v-layout>
                    <v-layout row wrap align-start>
                        <v-flex xs3>
                            <p class="caption font-weight-bold">Steps:</p>
                        </v-flex>
                        <v-flex xs9>
                            <p class="goal-text">{{ goalSteps }}</p>
                        </v-flex>
                    </v-layout>
                    <v-layout row wrap align-start>
                        <v-flex xs3>
                            <p class="caption font-weight-bold">Barrier:</p>
                        </v-flex>
                        <v-flex xs9>
                            <p class="goal-text">{{ goalBarrier }}</p>
                        </v-flex>
                    </v-layout>
                    <v-layout row wrap align-start>
                        <v-flex xs3>
                            <p class="caption font-weight-bold">Plan:</p>
                        </v-flex>
                        <v-flex xs9>
                            <p class="goal-text">{{ goalPlan }}</p>
                        </v-flex>
                    </v-layout>
                </v-container>
            </div>
        </v-slide-x-reverse-transition>
        <template v-slot:actions>
            <v-spacer></v-spacer>
            <v-btn round large color="primary" @click="nextClick()" :disabled="nextDisabled()">Next</v-btn>
            <v-spacer></v-spacer>
        </template>
    </CardPage>
</template>

<script>
import router from '@/router';
import { get } from 'vuex-pathify';

export default {
    data() {
        return {
            step: 1,
            goal: 1
        };
    },
    computed: {
        myGoals: get('section4/myGoals'),
        myGoalsCount: get('section4/myGoalsCount'),
        goalCategory() {
            return get(`section4/myGoals@${this.goal}.category`);
        },
        goalText() {
            return get(`section4/myGoals@${this.goal}.text`);
        },
        goalSteps: {
            get() {
                return this.$store.get(`section4/myGoals@${this.goal}.steps`);
            },
            set(value) {
                this.$store.set(`section4/myGoals@${this.goal}.steps`, value);
            }
        },
        goalBarrier: {
            get() {
                return this.$store.get(`section4/myGoals@${this.goal}.barrier`);
            },
            set(value) {
                this.$store.set(`section4/myGoals@${this.goal}.barrier`, value);
            }
        },
        goalPlan: {
            get() {
                return this.$store.get(`section4/myGoals@${this.goal}.plan`);
            },
            set(value) {
                this.$store.set(`section4/myGoals@${this.goal}.plan`, value);
            }
        }
    },
    methods: {
        backClick() {
            if (1 === this.step && 1 === this.goal) {
                router.back();
            } else if (1 === this.step && this.goal > 1) {
                this.step = 6;
                this.goal = this.goal - 1;
            } else {
                this.step = this.step - 1;
            }
        },
        nextClick() {
            if (6 === this.step && this.myGoalsCount === this.goal) {
                this.$refs.cardPage.nextClick();
            } else if (6 === this.step && this.goal < this.myGoalsCount) {
                this.step = 1;
                this.goal = this.goal + 1;
            } else {
                this.step = this.step + 1;
            }
        },
        nextDisabled() {
            return (
                (2 === this.step && !this.$store.get(`section4/myGoals@${this.goal}.steps`)) ||
                (3 === this.step && !this.$store.get(`section4/myGoals@${this.goal}.barrier`)) ||
                (4 === this.step && !this.$store.get(`section4/myGoals@${this.goal}.plan`))
            );
        }
    }
};
</script>

<style scoped>
.goal-text {
    white-space: pre-wrap;
}
</style>
